import React from 'react'
import {
  render,
} from 'react-dom'
import { defineCustomElements, applyPolyfills } from '@tarojs/components/loader'

import './style/index.less'
import App from './App'
import { installErrorDumpGlobal } from './utils/errorDump'

import '@tarojs/components/dist/taro-components/taro-components.css'

// 挂全局错误日志查看入口：window.__ERROR_LOG__.getAll() / last() / copy() / clear()
installErrorDumpGlobal()

applyPolyfills().then(function () {
  defineCustomElements(window)
})

window.onload = () => {
  // 安全插件注入后再渲染
  render(<App />, document.getElementById('root'))
}